module.exports = __webpack_public_path__ + "static/media/aroldo-comemorando-direita.e838d442.svg";